import EFPicture from '@elem/compCommon/EFPicture';
import { FormatMoneyLocal } from '@elem/compCommon/ShopifyShoppingCart/const';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import { createPortal } from 'react-dom';
import Question from '../Step2/A/icons/Question';
import QuestionHover from '../Step2/A/icons/QuestionHover';
import QuestionModal from '../Step2/A/QuestionModal';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';

export default function Step3({ calcObj, callback }: any) {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('dpu_calculator');
    const [showExtend, setShowExtend] = useState(false);
    const { check1, totalWatt, totalPower, dpuNum, ebNum, peakCharges, offpeakCharges, bill, checkB, totalDiscount, energy } = calcObj;
    const [showQuote, setShowQuote] = useState(false);
    const [initP, setInitP] = useState(false);
    const [initE, setInitE] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [question, setQuestion] = useState(null);
    const [recommandTime, setRecommandTime] = useState(0);
    const [batteryTime, setBatteryTime] = useState(0);
    const [solarTime, setSolarTime] = useState(0);
    const [backTime, setBackTime] = useState(0);
    const [monSave, setMonSave] = useState(0);
    const [payback, setPayback] = useState(0);
    const [basicW, setBasicW] = useState(0);
    const [batteryCss, setBatteryCss] = useState({ width: 0, left: 0 });
    const [solarCss, setSolarCss] = useState({ width: 0, left: 0 });
    const [showTC, setShowTC] = useState(false);

    const allProducts = [
        {
            id: 'dpu',
            img: '/responsive/picture/common-products/DPU.png',
            title: t('step3_dpu'),
            // discountPrice: 15136,
            // originalPrice: 12299,
            quantity: dpuNum,
            productId: (() => {
                const localMap: any = {
                    us: '6964802453577',
                    ca: '8006700236954',
                };
                return localMap[locale] || undefined;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40758830071881',
                    ca: '44244774650010',
                };
                return localMap[locale] || undefined;
            })(),
        },
        {
            id: 'shp2',
            img: '/responsive/picture/common-products/shp2_front.png',
            title: t('step3_shp2'),
            // discountPrice: 6199,
            // originalPrice: 5099,
            quantity: 1,
            canRemove: true,
            productId: (() => {
                const LocalMap: any = {
                    us: '6964802486345',
                    ca: '8006700761242',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '40767883575369',
                    ca: '44244781531290',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        },
        {
            id: 'dpu_eb',
            img: '/responsive/picture/common-products/DPU_Battery.png',
            title: t('step3_eb'),
            // discountPrice: 999,
            // originalPrice: 999,
            quantity: ebNum,
            productId: (() => {
                const localMap: any = {
                    us: '6981502206025',
                    ca: '8012436209818',
                };
                return localMap[locale] || undefined;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40832693764169',
                    ca: '44960085639322',
                };
                return localMap[locale] || undefined;
            })(),
        },
    ];
    const [products, setProducts] = useState(allProducts);

    const extendProducts = [
        {
            id: 'dpu_eb',
            img: '/responsive/picture/common-products/DPU_Battery.png',
            title: t('step3_eb'),
            // discountPrice: 2399,
            // originalPrice: 2999,
            quantity: 0,
            productId: (() => {
                const localMap: any = {
                    us: '6981502206025',
                    ca: '8012436209818',
                };
                return localMap[locale] || undefined;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40832693764169',
                    ca: '44960085639322',
                };
                return localMap[locale] || undefined;
            })(),
            max: 4 * dpuNum - ebNum,
        },
        {
            id: '400w',
            img: '/responsive/picture/common-products/400w.png',
            title: t('step3_400w'),
            // discountPrice: 2199,
            // originalPrice: 2199,
            quantity: 0,
            productId: (() => {
                const LocalMap: any = {
                    us: '6618094960713',
                    ca: '7287920001178',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '39998021697609',
                    ca: '42092770263194',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            max: 14 * dpuNum,
        },
    ];

    const [extds, setExtends] = useState(extendProducts);

    const handleExtend = () => {
        setShowExtend(!showExtend);
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_preview_page',
            list_name: t('step3_to_extend'),
            button_name: t('step3_to_extend'),
        });
    };

    const handleRemove = (product: any) => {
        const all = JSON.parse(JSON.stringify(products));
        const idx = all?.findIndex((p: any) => p.id === product.id);
        if (idx !== -1) {
            setProducts([...all.slice(0, idx), { ...product, remove: !product?.remove }, ...all.slice(idx + 1)]);
            callback({ ...calcObj, remove: !product?.remove });
        }
    };

    const handleBack = () => {
        callback({ ...calcObj, step: 2 });
        const both = extds[0]?.quantity > 0 && extds[1]?.quantity > 0;
        let strs = '';
        products?.map((p: any, k: number) => {
            if (k !== 0 && !p?.remove && p.quantity > 0) {
                strs += '_';
            }
            if (!p?.remove && p.quantity > 0) {
                strs += `${p.title}_${p.quantity}`;
            }
        });
        extds?.map((e: any) => {
            if (e?.quantity > 0) {
                strs += `_${e.title}_${e.quantity}`;
            }
        });

        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'calculator4_solar_generator',
                step: t('header_step3'),
                product_name: t(`header_step1${calcObj?.check1 === 2 ? '_b' : ''}`),
                option_name: t(`step1_text${calcObj?.check1}`),
                combo: (extds[0]?.quantity > 0 ? extds[0]?.title : '') + (both ? '_' : '') + (extds[1]?.quantity > 0 ? extds[1]?.title : ''),
                add_on: strs,
                price: calcObj?.totalDiscount,
                button_name: t('footer_back'),
            });
        } catch (e) {
            console.error(e);
        }
    };

    const handleCount = (data: any, num: number) => {
        const newObj = JSON.parse(JSON.stringify(extds));
        const target: any = newObj.find(
            (obj: any) =>
                obj.productId === data.productId &&
                obj.variantId === data.variantId &&
                (data?.parentVariantId ? data?.parentVariantId === obj?.parentVariantId : true),
        );
        if (num >= 0) {
            target.quantity = num;
            setExtends(newObj);
            callback({ ...calcObj, extend: newObj });
        }
    };

    const handleOpenQuote = () => {
        setShowQuote(true);
        let strs = '';
        products?.map((p: any, k: number) => {
            if (k !== 0 && !p?.remove && p?.quantity > 0) {
                strs += '_';
            }
            if (!p?.remove && p.quantity > 0) {
                strs += `${p.title}`;
            }
        });
        extds?.map((e: any) => {
            if (e.quantity > 0) {
                strs += `_${e.title}`;
            }
        });
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_get_a_quote',
            product_name: t(`header_step1${calcObj?.check1 === 2 ? '_b' : ''}`),
            position: t('step3_get_quote'),
            option_name: strs,
        });
    };

    const handleOpenQuestion = (exd?: any) => {
        if (exd?.id === 'dpu_eb') {
            setQuestion({ text: t('step3_question_eb') });
        }
        if (exd?.id === '400w') {
            setQuestion({ text: t('step3_question_sp') });
        }
        if (!exd) {
            setQuestion({ text: t('step3_question_error') });
        }
    };

    const AddSubtractor = ({ data, callback }: any) => {
        const NUM_MIN = 0;
        const NUM_MAX = (() => {
            return data?.inventory > 0 ? (data?.inventory >= data?.max ? data?.max : data?.inventory) : 0;
        })();
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 0);

        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_remove_from_cart',
                    list_name: t('step3_to_extend'),
                    product_name: data?.title,
                    price: data?.discountPrice,
                    tag: 'none',
                    quantity: number - 1,
                    button_name: 'remove',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const addNumber = () => {
            if (number >= NUM_MAX) return false;
            setNumber(number + 1);
            callback(data, number + 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    list_name: t('step3_to_extend'),
                    product_name: data?.title,
                    price: data?.discountPrice,
                    tag: 'none',
                    quantity: number + 1,
                    button_name: 'add',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v));
        };

        return (
            <div className="addSubtractor">
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="0.0390625" y="0.494995" width="23.0099" height="23.0099" rx="11.505" fill="#343434" />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.94275 12.5225H15.1432C15.3134 12.5225 15.4532 12.4734 15.5625 12.3754C15.6719 12.2773 15.7266 12.152 15.7266 11.9995C15.7266 11.847 15.6719 11.7217 15.5625 11.6236C15.4532 11.5256 15.3134 11.4766 15.1432 11.4766H7.94275C7.7726 11.4766 7.63283 11.5256 7.52345 11.6236C7.41407 11.7217 7.35938 11.847 7.35938 11.9995C7.35938 12.152 7.41407 12.2773 7.52345 12.3754C7.63283 12.4734 7.7726 12.5225 7.94275 12.5225Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <input
                    className="addSubtractor-number"
                    autoFocus={focus === (data?.parentVariantId ? `${data?.parentVariantId}_${data?.variantId}` : data?.variantId)}
                    value={number}
                    onChange={inputChange}
                />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
                        <rect x="-0.00976562" y="0.494995" width="23.0099" height="23.0099" rx="11.505" fill="#343434" />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.89392 12.5835H10.9108V15.6004C10.9108 15.7705 10.9655 15.9103 11.0749 16.0197C11.1842 16.1291 11.324 16.1838 11.4942 16.1838C11.6643 16.1838 11.8041 16.1291 11.9135 16.0197C12.0228 15.9103 12.0775 15.7705 12.0775 15.6004V12.5835H15.0944C15.2646 12.5835 15.4043 12.5288 15.5137 12.4194C15.6231 12.3101 15.6778 12.1703 15.6778 12.0001C15.6778 11.83 15.6231 11.6902 15.5137 11.5808C15.4043 11.4715 15.2646 11.4168 15.0944 11.4168H12.0775V8.3999C12.0775 8.22975 12.0228 8.08999 11.9135 7.9806C11.8041 7.87122 11.6643 7.81653 11.4942 7.81653C11.324 7.81653 11.1842 7.87122 11.0749 7.9806C10.9655 8.08999 10.9108 8.22975 10.9108 8.3999V11.4168H7.89392C7.72377 11.4168 7.584 11.4715 7.47462 11.5808C7.36524 11.6902 7.31055 11.83 7.31055 12.0001C7.31055 12.1703 7.36524 12.3101 7.47462 12.4194C7.584 12.5288 7.72377 12.5835 7.89392 12.5835Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </div>
        );
    };

    useEffect(() => {
        setPayback((totalDiscount * 0.7) / (monSave * 12));
    }, [totalDiscount, monSave]);

    useEffect(() => {
        if (monSave < 0 || payback < 0) {
            setQuestion({ text: t('step3_question_error') });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [payback, monSave]);

    useEffect(() => {
        setMonSave(bill - offpeakCharges * energy + 0.4 * extds[1]?.quantity * 5 * 0.9 * peakCharges * 30);
        // if (extds[1]?.quantity > 0) {
        // setMonSave(bill - offpeakCharges * (totalPower / 1000 / 24) * 19 * 30 + 0.4 * extds[1]?.quantity * 0.9 * peakCharges);
        // } else {
        //     setMonSave(bill - (offpeakCharges * totalPower) / 1000);
        // }
    }, [bill, offpeakCharges, totalPower, extds, peakCharges]);

    useEffect(() => {
        setBackTime(recommandTime + batteryTime + solarTime);
        const isH5 = window?.innerWidth < 768;
        const basicEl = document.querySelector('.dpu-calculator-step3 .bar-box .bars .basic') as HTMLDivElement;
        const batteryEl = document.querySelector('.dpu-calculator-step3 .bar-box .bars .battery') as HTMLDivElement;
        const solarEl = document.querySelector('.dpu-calculator-step3 .bar-box .bars .solar') as HTMLDivElement;
        const totalTime = recommandTime + batteryTime + solarTime;
        if (basicEl) {
            const basicWidth = `${(recommandTime / totalTime) * 100}%`;
            setBasicW(basicWidth);
            const dx = isH5 ? '4px' : '10px';
            if (batteryEl) {
                setBatteryCss({ width: `calc(${`${(batteryTime / totalTime) * 100}%`} + ${dx})`, left: `calc(${basicWidth} - ${dx})` });
            }
            if (solarEl) {
                const otherWidth = `${((recommandTime + batteryTime) / totalTime) * 100}%`;
                setSolarCss({ width: `calc(${`${(solarTime / totalTime) * 100}%`} + ${dx})`, left: `calc(${otherWidth} - ${dx})` });
            }
        }
    }, [recommandTime, batteryTime, solarTime]);

    useEffect(() => {
        setRecommandTime((((dpuNum + ebNum) * 6.144) / (totalPower / 1000)) * 24);
    }, [dpuNum, ebNum, totalPower]);

    useEffect(() => {
        setBatteryTime((((extds[0]?.quantity || 0) * 6.144) / (totalPower / 1000)) * 24);
    }, [extds, totalPower]);

    useEffect(() => {
        setSolarTime((((extds[1]?.quantity || 0) * 0.4 * 5 * 0.9) / (totalPower / 1000 / 24)) * 0.9);
    }, [extds, totalPower]);

    useEffect(() => {
        callback({ ...calcObj, products });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [products]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(allProducts));
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].discountPrice = res?.data?.price;
                        tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                        // tempArr[k].inventory = 1;
                        // tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };

        const promises = [];
        tempArr?.map((item: any, k: number) => {
            if (item?.variantId) {
                promises.push(getAsynItem(item?.productId, item.variantId, k));
            }
        });

        Promise.all(promises)
            .then(() => {
                setProducts(tempArr?.filter((list: any) => list?.inventory !== undefined && list?.quantity > 0));
                setInitP(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(extendProducts));
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].discountPrice = res?.data?.price;
                        tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                        // tempArr[k].inventory = 1;
                        // tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };

        const promises = [];
        tempArr?.map((item: any, k: number) => {
            if (item?.variantId) {
                promises.push(getAsynItem(item?.productId, item.variantId, k));
            }
        });

        Promise.all(promises)
            .then(() => {
                setExtends(tempArr?.filter((list: any) => list?.inventory !== undefined));
                setInitE(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        if (initE && initP) {
            let discount = 0,
                original = 0,
                link_buy = `https://${locale}.ecoflow.com/cart/`;
            products?.map((p: any, k: number) => {
                discount += (p?.remove ? 0 : p?.discountPrice || 0) * (p?.quantity || 0);
                original += (p?.remove ? 0 : p?.originalPrice || 0) * (p?.quantity || 0);
                if (!p?.remove) {
                    link_buy += `${k > 0 ? ',' : ''}${p?.variantId}:${p?.quantity}`;
                }
            });
            extds?.map((e: any) => {
                discount += (e?.discountPrice || 0) * (e?.quantity || 0);
                original += (e?.originalPrice || 0) * (e?.quantity || 0);
                if (e?.quantity > 0) {
                    link_buy += `,${e?.variantId}:${e?.quantity}`;
                }
            });
            link_buy += '?channel=buy_button';
            callback({ ...calcObj, totalDiscount: discount, totalOriginal: original, link_buy });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initE, initP, products, extds]);

    return (
        <div className={`dpu-calculator-step3 ${css['dpu-calculator-step3']}`}>
            <span className="back h5" onClick={handleBack}>
                &lt; {t('footer_back')}
            </span>
            <p className="title">{t('step3_title')}</p>
            <div className="inner-box">
                <span className="back pc" onClick={handleBack}>
                    &lt; {t('footer_back')}
                </span>
                {check1 === 1 && (
                    <div className="report-box">
                        <p className="box-title">{t('step3_A_report')}</p>
                        <div className="report-inner">
                            <div className="inner-item">
                                <p className="item-label">{t('step3_A_power')}</p>
                                <p className="item-value">
                                    {totalWatt} {t('step3_W')}
                                </p>
                            </div>
                            <div className="inner-item">
                                <p className="item-label">{t('step3_A_energy')}</p>
                                <p className="item-value">
                                    {Math.round((totalPower * 100) / 1000) / 100} {t('step3_kwh_day')}
                                </p>
                            </div>
                            <div className="inner-item">
                                <p className="item-label">{t('step3_A_estimate')}</p>
                                <p className="item-value">
                                    {Math.round((((dpuNum + ebNum) * 6144) / totalPower) * 100) / 100} {t('step3_days')}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                <div className="solution-box">
                    <p className="box-title">{t('step3_solution')}</p>
                    <ul className="products pc">
                        {products?.map((product: any, k: number) => (
                            <li className={`product ${product?.canRemove && product?.remove ? 'remove' : ''}`} key={k}>
                                <div className="p-l">
                                    <div className="p-img">
                                        <EFPicture src={product?.img} alt={product?.title} />
                                    </div>
                                    <div className="p-info">
                                        <p className="p-title">{product?.title}</p>
                                        {product?.canRemove && (
                                            <span className="p-remove pc" onClick={() => handleRemove(product)}>
                                                {product?.remove ? t('step3_addback') : t('step3_remove')}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="p-r">
                                    <div className="p-num">&times; {product?.quantity}</div>
                                    <div className="p-price">
                                        <span className="price-discount">{FormatMoneyLocal(product?.discountPrice, locale)}</span>
                                        {product?.discountPrice !== product?.originalPrice && (
                                            <span className="price-original">{FormatMoneyLocal(product?.originalPrice, locale)}</span>
                                        )}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <ul className="products h5">
                        {products?.map((product: any, k: number) => (
                            <li className={`product ${product?.canRemove && product?.remove ? 'remove' : ''}`} key={k}>
                                <div className="p-l">
                                    <div className="p-img">
                                        <EFPicture src={product?.img} alt={product?.title} />
                                    </div>
                                </div>
                                <div className="p-r">
                                    <div className="p-info">
                                        <p className="p-title">{product?.title}</p>
                                    </div>
                                    <div className="p-price-num">
                                        <div className="p-price">
                                            <span className="price-discount">{FormatMoneyLocal(product?.discountPrice, locale)}</span>
                                            {product?.discountPrice !== product?.originalPrice && (
                                                <span className="price-original">{FormatMoneyLocal(product?.originalPrice, locale)}</span>
                                            )}
                                        </div>
                                        <div className="p-num">&times; {product?.quantity}</div>
                                    </div>
                                    {product?.canRemove && (
                                        <span className="p-remove" onClick={() => handleRemove(product)}>
                                            {product?.remove ? t('step3_addback') : t('step3_remove')}
                                        </span>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                    {check1 === 2 && (
                        <div className="bar-box">
                            <div className="info-box">
                                <div className="info-item">
                                    <p className="item-k">{t('step3_B_daily_power')}</p>
                                    <p className="item-v">
                                        {Math.round((totalPower * 100) / 1000) / 100} {t('step3_kwh')}
                                    </p>
                                </div>
                                <div className="info-item">
                                    <p className="item-k">{t('step3_B_satisfied')}</p>
                                    <p className="item-v">
                                        {Math.round(100 * backTime) / 100} {t('step3_B_backup_time')}
                                    </p>
                                </div>
                            </div>
                            <div className="bars">
                                <div className="basic" style={{ width: basicW }}>
                                    <span className="text">
                                        {Math.round(100 * recommandTime) / 100}
                                        {t('step3_B_h')}
                                    </span>
                                </div>
                                {extds[0]?.quantity > 0 && (
                                    <div className="battery" style={{ ...batteryCss }}>
                                        <span className="text">
                                            {Math.round(100 * batteryTime) / 100}
                                            {t('step3_B_h')}
                                        </span>
                                    </div>
                                )}
                                {extds[1]?.quantity > 0 && (
                                    <div className="solar" style={{ ...solarCss }}>
                                        <span className="text">
                                            {Math.round(100 * solarTime) / 100}
                                            {t('step3_B_h')}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <div className="marks">
                                <span className="mark basic">{t('step3_B_mark_basic')}</span>
                                <span className="mark battery">{t('step3_B_mark_battery')}</span>
                                <span className="mark solar">{t('step3_B_mark_solar')}</span>
                            </div>
                        </div>
                    )}
                    <div className={`extend-box ${showExtend ? 'show' : 'hide'}`}>
                        <p className="extend-title" onClick={handleExtend}>
                            {t('step3_to_extend')}
                        </p>
                        <div className="extend-inner">
                            <ul className="extends">
                                {extds?.map((exd: any, k: number) => (
                                    <li className="extend" key={k}>
                                        <div className="e-l">
                                            <div className="e-img">
                                                <EFPicture src={exd?.img} alt={exd?.title} />
                                            </div>
                                            <div className="e-info">
                                                <div className="e-title-box">
                                                    <p className="e-title">{exd?.title}</p>
                                                    <div className="e-question" onClick={() => handleOpenQuestion(exd)}>
                                                        <Question />
                                                        <QuestionHover />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="e-r">
                                            <AddSubtractor data={exd} callback={handleCount} />
                                            <div className="e-price">
                                                <span className="price-discount">{FormatMoneyLocal(exd?.discountPrice, locale)}</span>
                                                {exd.discountPrice !== exd.originalPrice && (
                                                    <span className="price-original">{FormatMoneyLocal(exd?.originalPrice, locale)}</span>
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            {check1 === 1 && (
                                <p className="backup-sum">
                                    {t.rich('step3_backup_sum', {
                                        hours:
                                            Math.round(100 * ((6.144 * extds[0]?.quantity + extds[1]?.quantity * 0.4 * 5 * 0.9) / (totalWatt / 1000)) * 0.9) /
                                            100,
                                        b: (text: string) => <span className="b">{text}</span>,
                                    })}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className="free-quote" onClick={handleOpenQuote}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.5 12H17" stroke="#3F68E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M10.5 9H17" stroke="#3F68E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M17 15H10.5" stroke="#3F68E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path
                                d="M7 13.1443H4V18.2878C4.00293 19.2336 4.76865 19.9994 5.7145 20.0023"
                                stroke="#3F68E0"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.42935 4C7.87706 4 7.42935 4.44772 7.42935 5V18.2876C7.42642 19.2332 6.6607 19.9992 5.71484 20.0021H18.288C19.2335 19.9992 19.9995 19.2332 20.0021 18.2876V5C20.0021 4.44772 19.5544 4 19.0021 4H8.42935Z"
                                stroke="#3F68E0"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <span className="quote-text">{t('step3_get_quote')}</span>
                    </div>
                </div>
                {check1 === 2 && (
                    <div className="plan-box">
                        <div className="box-title">
                            {t('step3_B_plan')}
                            {(monSave < 0 || payback < 0) && (
                                <span className="title-question" onClick={() => handleOpenQuestion()}>
                                    <Question />
                                    <QuestionHover />
                                </span>
                            )}
                        </div>
                        <div className="plan-inner">
                            <div className="plan-item">
                                <p className="item-k">{t('step3_B_save')}</p>
                                <p className="item-v">
                                    {t('step2_B_currency')}
                                    {Math.round(100 * monSave) / 100}
                                    {t('step2_B_mon')}
                                </p>
                            </div>
                            <div className="plan-item">
                                <p className="item-k">{t('step3_B_period')}</p>
                                <p className="item-v">
                                    {Math.round(100 * payback) / 100} {t('step3_B_ira')}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                <div className="free-quote" onClick={() => setShowTC(true)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 12H17" stroke="#3F68E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.5 9H17" stroke="#3F68E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M17 15H10.5" stroke="#3F68E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path
                            d="M7 13.1443H4V18.2878C4.00293 19.2336 4.76865 19.9994 5.7145 20.0023"
                            stroke="#3F68E0"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.42935 4C7.87706 4 7.42935 4.44772 7.42935 5V18.2876C7.42642 19.2332 6.6607 19.9992 5.71484 20.0021H18.288C19.2335 19.9992 19.9995 19.2332 20.0021 18.2876V5C20.0021 4.44772 19.5544 4 19.0021 4H8.42935Z"
                            stroke="#3F68E0"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="quote-text">{t('step3_tc')}</span>
                </div>
            </div>
            {showQuote && ['us', 'ca'].includes(locale) && <QuoteWin callback={() => setShowQuote(false)} />}
            {question && isClient && createPortal(<QuestionModal app={question} callback={() => setQuestion(null)} />, document.body)}
            {showTC &&
                isClient &&
                createPortal(
                    <QuestionModal
                        isTC={true}
                        app={{
                            text: t.rich('tc', {
                                b: (text: string) => <span className="b">{text}</span>,
                            }),
                        }}
                        callback={() => setShowTC(false)}
                    />,
                    document.body,
                )}
        </div>
    );
}
